import { useMemo } from "react";
import { gql, useQuery as useAppSyncQuery } from "@apollo/client";
import { UseQueryResult } from "@tanstack/react-query";

const API_URL = "http://localhost:3000/pcs";

export interface PCRoom {
  PlanOnId: string;
  Label: string;
  InUse: number;
  Available: number;
  Offline: number;
  TurnedOn: number;
  Total: number;
  OrderNum: number;
  Bookable: boolean;
  Booked: boolean;
  BookingInfo: string;
  Latitude: number;
  Longitude: number;
}

export interface AllPCsResponse {
  PublicApiStationSetId: number;
  Name: string;
  ChangeSpeed: number;
  InUse: number;
  Available: number;
  Offline: number;
  Total: number;
  Groups: PCRoom[];
}

const GET_ALL_PCS = gql`
  query GetAllPCs {
    getPCs {
      Available
      ChangeSpeed
      Groups {
        Available
        Bookable
        Booked
        BookingInfo
        InUse
        Latitude
        Label
        Longitude
        Offline
        OrderNum
        PlanOnId
        Total
        TurnedOn
      }
      InUse
      Offline
      Name
      PublicApiStationSetId
      Total
    }
  }
`;
export const usePCs = (): UseQueryResult<AllPCsResponse> => {
  const { data, loading, error } = useAppSyncQuery<{ getPCs: AllPCsResponse }>(
    GET_ALL_PCS
  );

  return {
    data: data?.getPCs,
    isLoading: loading,
    isError: !!error,
    error: error,
    isSuccess: !!data,
  } as UseQueryResult<AllPCsResponse>;
};

export const usePC = (pcId?: string) => {
  const pcs = usePCs();

  const pc = useMemo(() => {
    return pcs.data?.Groups.find((e) => e.PlanOnId === pcId);
  }, [pcId, pcs]);

  return { ...pcs, data: pc };
};
